import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RotateCcw, UserRound } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuInput } from "../../components/neu/Neu";
import { avatarEmployees, resetAvatars } from "../../api/platform";

// قائمة موظفي الشركة المختارة مع تصفير فردي أو جماعي (بتأكيد).
export const AvatarEmployeeList = ({ company, onChanged }) => {
  const { t } = useTranslation();
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [confirm, setConfirm] = useState(false);

  const load = async () => {
    try { setRows(await avatarEmployees(company.id, q.trim())); } catch { /* تجاهل */ }
  };
  useEffect(() => { setConfirm(false); setQ(""); load(); /* eslint-disable-next-line */ }, [company.id]);

  const reset = async (userId) => {
    try {
      const r = await resetAvatars({ company_id: company.id, ...(userId ? { user_id: userId } : {}) });
      toast.success(t("platform.avatarsPanel.done", { n: r.reset }));
      setConfirm(false); load(); onChanged?.();
    } catch { toast.error(t("errors.generic")); }
  };

  return (
    <div className="grid gap-3 rounded-2xl p-4 shadow-neu-in" data-testid="avatar-employee-list">
      <div className="flex items-center justify-between gap-2">
        <span className="min-w-0 truncate text-sm font-black">{company.name}</span>
        {confirm ? (
          <span className="flex shrink-0 items-center gap-2">
            <NeuButton variant="primary" onClick={() => reset()} className="px-3 py-1.5 text-xs" data-testid="avatar-reset-all-confirm">
              {t("platform.avatarsPanel.confirm")}
            </NeuButton>
            <NeuButton onClick={() => setConfirm(false)} className="px-3 py-1.5 text-xs">{t("platform.avatarsPanel.cancel")}</NeuButton>
          </span>
        ) : (
          <NeuButton onClick={() => setConfirm(true)} className="flex shrink-0 items-center gap-2 px-3 py-1.5 text-xs text-destructive" data-testid="avatar-reset-all">
            <RotateCcw className="h-3.5 w-3.5" /> {t("platform.avatarsPanel.resetAll")}
          </NeuButton>
        )}
      </div>

      <NeuInput value={q} placeholder={t("platform.avatarsPanel.searchEmployee")}
        onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} data-testid="avatar-emp-q" />

      <ul className="grid gap-2">
        {rows.length === 0 ? (
          <li className="py-4 text-center text-xs text-muted-foreground">{t("platform.avatarsPanel.noEmployees")}</li>
        ) : rows.map((u) => (
          <li key={u.id} className="flex items-center gap-3 rounded-xl bg-background px-3 py-2 shadow-neu-sm" data-testid={`avatar-emp-${u.id}`}>
            <UserRound className="h-4 w-4 shrink-0 text-muted-foreground" />
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-bold">{u.name}</span>
              <span className="block truncate text-[11px] text-muted-foreground" dir="ltr">{u.email}</span>
            </span>
            <span className={`shrink-0 text-[11px] font-bold ${u.has_avatar ? "text-emerald-600" : "text-muted-foreground"}`}>
              {u.has_avatar ? t("platform.avatarsPanel.hasAvatar") : t("platform.avatarsPanel.noAvatar")}
            </span>
            <NeuButton onClick={() => reset(u.id)} disabled={!u.has_avatar}
              className="shrink-0 px-3 py-1.5 text-xs text-primary disabled:opacity-40" data-testid={`avatar-reset-${u.id}`}>
              {t("platform.avatarsPanel.resetOne")}
            </NeuButton>
          </li>
        ))}
      </ul>
    </div>
  );
};
